import { actionTypes } from '../actions/types';

type AppActions = import('../actions/types').AppActions;

export interface NafFormType {
    telefonnummer: string | null;
    medlemsnummer: string | null;
    foedselsdato: string;
}

export interface NafReducer {
    isMember: boolean;
    errorMemberNoMatch: boolean;
    errorMemberUnderAge: boolean;
    errorBadRequest: boolean;
    nafVerifiseringsType: string;
    mobilnummer: string | null;
    medlemsnummer: string | null;
    foedselsdato: string | null;
}

export const initialState: NafReducer = {
    isMember: false,
    errorMemberNoMatch: false,
    errorMemberUnderAge: false,
    errorBadRequest: false,
    nafVerifiseringsType: '0',
    mobilnummer: null,
    medlemsnummer: null,
    foedselsdato: null,
};

export const nafReducer = (state = initialState, action: AppActions = {} as AppActions): NafReducer => {
    switch (action.type) {
        /* User: Context */
        case actionTypes.FETCH_USER_CONTEXT_FULFILLED: {
            const { telefon, foedselsdato } = action.payload;
            return {
                ...state,
                mobilnummer: state.mobilnummer || telefon,
                foedselsdato: state.foedselsdato || foedselsdato,
            };
        }

        /* NAF: Cache */
        case actionTypes.FETCH_NAF_CACHE_FULFILLED: {
            const { kunde, erMedlem } = action.payload;
            return {
                ...state,
                isMember: erMedlem === null ? state.isMember : erMedlem,
                medlemsnummer: kunde?.medlemsnummer || null,
            };
        }

        /* NAF: Member */
        case actionTypes.FETCH_NAF_MEMBER_FULFILLED: {
            const { kunde, erMedlem } = action.payload;
            return {
                ...state,
                isMember: erMedlem || false,
                errorMemberNoMatch: !erMedlem ? true : state.errorMemberNoMatch,
                medlemsnummer: kunde?.medlemsnummer || null,
            };
        }
        case actionTypes.FETCH_NAF_MEMBER_FAILED: {
            const { errorName } = action.payload;
            return {
                ...state,
                errorMemberUnderAge: errorName === 'NAF_UNDER_AGE' || state.errorMemberUnderAge,
                errorMemberNoMatch: errorName === 'NAF_FOEDSELSDATO_MATCHER_IKKE_FNR' || state.errorMemberNoMatch,
                errorBadRequest:
                    !['NAF_FOEDSELSDATO_MATCHER_IKKE_FNR', 'NAF_UNDER_AGE'].includes(errorName) ||
                    state.errorBadRequest,
            };
        }

        /* NAF: Fields */
        case actionTypes.FIELD_UPDATE_NAF_OPTION: {
            const { name, value } = action.payload;
            return {
                ...state,
                [name]: value,
            };
        }

        default:
            return state;
    }
};
